import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=51b94c66"
import script from "./CartDetail?vue&type=script&lang=ts&external"
export * from "./CartDetail?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports